import { render, staticRenderFns } from "./insured-vehicle-form.vue?vue&type=template&id=61ab7e46&scoped=true&"
import script from "./insured-vehicle-form.vue?vue&type=script&lang=js&"
export * from "./insured-vehicle-form.vue?vue&type=script&lang=js&"
import style0 from "./insured-vehicle-form.vue?vue&type=style&index=0&id=61ab7e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab7e46",
  null
  
)

export default component.exports